export const fudgeFactor = 0.6
export const f2 = fudgeFactor / 2
